import { useParams, useLocation } from "react-router-dom";
import { ConfirmationForm } from "../components/form/ConfirmationForm";
import React, { useEffect, useState } from "react";
import useFetchReview from "../hooks/useFetchReview";
import { Typography, Alert, Box } from "@mui/material";
import { splitTextIntoTitleAndBody } from "../helper/text";

export const ConfirmationPage = () => {
  let { token } = useParams();
  let location = useLocation();
  const { values } = location.state;
  const { data, error, loading } = useFetchReview(token);
  const [initialValues, setInitialValues] = useState({
    rating: 1,
    title: "",
    comment: "",
  });

  useEffect(() => {
    const textAndBody = splitTextIntoTitleAndBody(values.comment);

    setInitialValues({
      rating: Number(values.rating),
      title: textAndBody.title,
      comment: textAndBody.body,
    });

    return () => {
      setInitialValues({
        rating: 1,
        title: "",
        comment: "",
      });
    };
  }, []);

  if (loading) {
    return null;
  }

  if (error) {
    return (
      <Box id="page" sx={{ mt: 4 }}>
        <Alert severity="error">{error.message}</Alert>
      </Box>
    );
  }

  if (data.course.used) {
    return (
      <Box id="page" sx={{ mt: 4 }}>
        <Alert severity="info">
          Wir haben diese Bewertung bereits erhalten.
        </Alert>
      </Box>
    );
  }

  return (
    <Box id="page" sx={{ mt: 4 }}>
      <Typography variant="h2" component="h2" sx={{ mt: 4 }}>
        {data.course.code} - {data.course.title}
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 4 }}>
        {data.date}
      </Typography>
      <Alert severity="info" sx={{ mb: 4 }}>
        Wollen Sie Ihre Bewertung noch einmal anpassen?
      </Alert>
      <ConfirmationForm
        initialValues={{
          name: "",
          email: "",
          rating: initialValues.rating,
          title: initialValues.title,
          comment: initialValues.comment,
        }}
      />
    </Box>
  );
};
